export const onServiceWorkerUpdateReady = () => {
  console.log("Hey Update")
}

export const onServiceWorkerActive = () => {
  console.log("Hey Active")
  // setTimeout(function(){ window.location.reload() }, 30);
}

export const onServiceWorkerInstalled = () => {
  console.log("Hey Installed")
}
